import './Hero.css'

const ASCII_TITLE = `▒▓█▓▒░ ▒▓█▓▒░  ▒▓█████▓▒░ ▒▓███████▓▒░ ▒▓██████▓▒░░ ▒▓██████▓▒░  ▒▓█████▓▒░  ▒▓█████▓▒░
▒▓█▓▒░ ▒▓█▓▒░ ▒█▓▒░ ▒▓█▓▒░▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░     ▒▓█▓▒░      ▒▓█▓▒░
▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░     ▒▓█▓▒░      ▒▓█▓▒░
▒▓████████▓▒░▒▓████████▓▒░▒▓█████▓▒░░  ▒▓█▓▒░ ▒▓█▓▒░▒▓█████▓▒░   ▒▓███▓▒░    ▒▓███▓▒░
▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░ ▒▓█▒░ ▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░            ▒█▓▒░       ▒█▓▒░
▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░            ▒█▓▒░       ▒█▓▒░
▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░ ▒▓█▓▒░▒▓█▓▒░ ▒▓█▓▒░▒▓████████▓▒░▒▓████▓▒░ ▒▓█████▓▒░`

export function Hero() {
  return (
    <section className="hero">
      {/* title-ascii: 6:18 */}
      <div className="hero__title-ascii">
        <pre className="hero__ascii-text">{ASCII_TITLE}</pre>
      </div>

      {/* title-text: 7:22 */}
      <div className="hero__title-text">
        <p className="hero__slogan">
          <span className="hero__slogan-keyword">Agents</span> <span className="hero__slogan-keyword">that</span> <span className="hero__slogan-keyword">save</span> <span className="hero__slogan-keyword">explore</span> <span className="hero__slogan-keyword">recover</span> <span className="hero__slogan-keyword">on</span> <span className="hero__slogan-keyword">their</span> <span className="hero__slogan-keyword">own</span>
        </p>
        <p className="hero__description">
          Harness is an agent sandbox where agents checkpoint, branch, and rollback on their own, enabling safe experimentation and parallel exploration.
        </p>
      </div>
    </section>
  )
}
